import React from 'react';
import HomePage from './pages/HomePage';
import ReduxExamplePage from './pages/ReduxExamplePage';
import ErrorBoundaryExamplePage from './pages/ErrorBoundaryExamplePage/ErrorBoundaryExamplePage';
import FormValidationExamplePage from './pages/FormValidationExamplePage';
import MockApiExamplePage from './pages/MockApiExamplePage';
import DynamicImportExamplePage from './pages/DynamicImportExamplePage';
import LazyLoadComponentExamplePage from './pages/LazyLoadComponentExamplePage';

/* eslint-disable react/display-name, react/no-multi-comp */
const routes = [
  {
    path: '/',
    exact: true,
    label: 'Home',
    main: () => <HomePage />
  },
  {
    path: '/redux',
    label: 'Example: Redux App',
    main: () => <ReduxExamplePage />
  },
  {
    path: '/formValidation',
    label: 'Example: Form Validation',
    main: () => <FormValidationExamplePage />
  },
  {
    path: '/errorBoundaries',
    label: 'Example: Error Boundaries',
    main: () => <ErrorBoundaryExamplePage />
  },
  {
    path: '/mockapi',
    label: 'Example: Mock API',
    main: () => <MockApiExamplePage />
  },
  {
    path: '/dynamic-imports',
    label: 'Example: Dynamic Imports',
    main: () => <DynamicImportExamplePage />
  },
  {
    path: '/lazy-load-components',
    label: 'Example: Lazy Components',
    main: () => <LazyLoadComponentExamplePage />
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/components/routes.js